import { render } from "./ContactFaq.vue?vue&type=template&id=1dcb0cfc&ts=true"
import script from "./ContactFaq.vue?vue&type=script&lang=ts"
export * from "./ContactFaq.vue?vue&type=script&lang=ts"

import "./ContactFaq.vue?vue&type=style&index=0&id=1dcb0cfc&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__